/* eslint-disable camelcase, import/prefer-default-export  */
import { AxiosResponse } from 'axios';

export const API = 'permission/role/doCreate';

type p5_role_status = '3' | '-2' //  狀態:3.啟用 -2.停用
type p5_role_name = string //  名稱
type p5_role_memo = string // 備註

export interface request {
    p5_role_status: p5_role_status,
    p5_role_name: p5_role_name,
    p5_role_memo?: p5_role_memo,
}

export interface AxiosResponse extends AxiosResponse<responseData> { }

interface responseData extends backendResponse {
  response: any
}
